function normalizeDateParts(year: number, month: number, day: number) {
	if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return null;
	const date = new Date(Date.UTC(year, month - 1, day));
	if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
	return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function normalizeAbsoluteDateValue(value: string) {
	const rawValue = value.replace(/^\s*(>=|<=|>|<)\s*/, "").trim();
	let match = rawValue.match(/^(\d{4})[-\/]([0-1]?\d)[-\/]([0-3]?\d)$/);
	if (match) return normalizeDateParts(Number(match[1]), Number(match[2]), Number(match[3]));

	match = rawValue.match(/^([0-1]?\d)[-\/]([0-3]?\d)[-\/](\d{4})$/);
	if (match) return normalizeDateParts(Number(match[3]), Number(match[1]), Number(match[2]));
	return null;
}

export function isDateAfterLimit(value: string, limit: string) {
	const normalizedValue = normalizeAbsoluteDateValue(value);
	const normalizedLimit = normalizeAbsoluteDateValue(limit);
	return Boolean(normalizedValue && normalizedLimit && normalizedValue > normalizedLimit);
}

export function isForwardRelativeDateValue(value: string) {
	return /\sforwards?\s*$/i.test(value.trim());
}
